import saveRegisterClient from './saveRegisterClient'

export const saveRegisterClientPromise = saveRegisterClient
